import { useEffect, useState } from "@wordpress/element";
import { MdOutlineTrendingDown, MdOutlineTrendingFlat, MdOutlineTrendingUp } from "react-icons/md";
import { Legend, Pie, PieChart, ResponsiveContainer } from "recharts";

const renderColorfulLegendText = (value, entry) => {
    return (
        <span style={{ color: entry?.payload?.value == 101 ? "#BCC3D0" : "#596579", fontWeight: 500 }}>
            {value}
        </span>
    );
};

export default function GraficoStatus({ data }) {
    const [cores, setCores] = useState({ mesAtual: "#BCC3D0", mesAnterior: "#BCC3D0" })

    useEffect(() => {
        if (data) {
            if (data?.mudancaPorcentagem != null)
                setCores({ mesAtual: "#56A55C", mesAnterior: "#95E1AF" })
        }
    }, [data]);

    const validacaoRetorno = (data, valor) => !data ? 101 : valor
    
    return (
        <ResponsiveContainer width="100%" >
            <PieChart>
                <Pie

                    data={[
                        { name: "Mês Atual", value: validacaoRetorno(data, Math.abs(data?.mudancaPorcentagem)), fill: cores.mesAtual },
                        { name: "Mês Anterior", value: validacaoRetorno(data, 100 - Math.abs(data?.mudancaPorcentagem)), fill: cores.mesAnterior },
                    ]}
                    innerRadius="45%"
                    outerRadius="100%"
                    cy="47%"
                    fill="#8884d8"
                    dataKey="value"
                >
                </Pie>
                <Legend
                    iconType="square"
                    layout="vertical"
                    formatter={renderColorfulLegendText}
                />
            </PieChart>
        </ResponsiveContainer>
    )
}